import { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination, Navigation } from 'swiper'
import { Link } from 'react-router-dom'

import { sanitizeImageUrl } from 'utils'
import { useDataContext } from 'context/data-context'
import { Featured, SlideContent, Detail, Progress } from './styled'

const SLIDE_GAP = 30
const SLIDE_DURATION_SEC = 3

export const FeaturedSlider = () => {
  const { people, translate } = useDataContext()
  const [isPaused, setIsPaused] = useState(false)
  const [slideIndex, setSlideIndex] = useState(-1)

  return (
    <Featured slideGap={SLIDE_GAP} slideDuration={SLIDE_DURATION_SEC}>
      <Swiper
        onAutoplayPause={() => setIsPaused(true)}
        onAutoplayResume={() => setIsPaused(false)}
        slidesPerView="auto"
        centeredSlides
        pagination={{
          clickable: true,
        }}
        onSlideChange={(swiper) => setSlideIndex(swiper.activeIndex)}
        spaceBetween={SLIDE_GAP}
        modules={[Autoplay, Pagination, Navigation]}
        autoplay={{
          delay: SLIDE_DURATION_SEC * 1000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        speed={500}
        navigation
        draggable
        loop
      >
        {people
          .filter((p) => p.Featured)
          .map((p) => (
            <SwiperSlide key={p.id}>
              <SlideContent>
                <img src={sanitizeImageUrl(p.Photo_URL, 500)} alt={p.Name} />
                <Detail>
                  <h3>{p.Name}</h3>
                  <p>{p['Short text for the Featured']}</p>
                  <Link to={`/detail/${p.id}`}>
                    {translate('See more button for Featured')}
                  </Link>
                </Detail>
              </SlideContent>
            </SwiperSlide>
          ))}
      </Swiper>

      <Progress key={slideIndex.toString()} isPaused={isPaused} />
    </Featured>
  )
}
